export const locale = {
  selectCompareDate: 'Select compare date',
  date: 'Select Date',
  time: 'Select Time',
  apply: 'Apply'
};
